import React, {Component, Fragment} from "react"
import browserImageSize from "browser-image-size"

import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import addTrophy from "@irati/ui/images/trophy-empty.png"
import getBase64 from "@irati/utils/images/getBase64"
import {uploadImage} from "@irati/images/services/image"
import Loading from "@irati/ui/src/Loading"
import TrophyImg from "@irati/ui/src/Trophy"
import StyledDropzone from "./Dropzone"
import {CustomTrophyWrapper, CustomTrophyText} from "./styled"

const MAX_SIZE = 2
const MAX_SIZE_BYTES = MAX_SIZE * 1024 * 1024

interface Dimensions {
  width: number,
  height: number
}

interface Props extends InjectIntl{
  id?: string,
  onUpload(uploaded: string): void,
  property?: string,
  selected: boolean,
  setError(error: string): void,
  trophy?: string
}

interface State {
  load?: Promise<void>,
  trophy?: string
}

class CustomTrophy extends Component<Props, State> {
  static defaultProps = {
    property: "cardImage",
    id: "uploadImage",
    trophy: undefined
  }

  constructor(props: Props) {
    super(props)
    const {trophy} = this.props

    this.state = {
      load: undefined,
      trophy
    }
  }

  handleUpload = (file: any) => {
    const {onUpload} = this.props
    return uploadImage(file).then((imgUrl: string) => {
      this.setState({
        load: undefined,
        trophy: imgUrl
      })
      onUpload(imgUrl)
    })
  }

  handleTooSmall = () => {
    const {formatMessage, setError} = this.props
    setError(formatMessage({id: "platform.fields.trophy.uploadImage.uploadFailed.error"}))
    this.setState({load: undefined})
  }

  handleDrop = (acceptedFile: any, rejectedFile: any) => {
    const {setError, formatMessage} = this.props
    const dimensions: Dimensions = {
      width: 165,
      height: 165
    }
    if (rejectedFile.length > 0) {
      setError(formatMessage({id: "platform.fields.trophy.uploadImage.uploadError"}, {maxSize: MAX_SIZE}))
    } else {
      return getBase64(acceptedFile[0]).then((base64Image: string) => {
        const load: Promise<void> = browserImageSize(base64Image)
          .then((size: Dimensions) => {
            if (size.width < dimensions.width || size.height < dimensions.height) {
              return this.handleTooSmall()
            }
            return this.handleUpload(base64Image)
          })
        this.setState({load})
      })
    }
  }

  render() {
    const {load, trophy} = this.state
    const {selected} = this.props
    return (
      <StyledDropzone
        className="trophy-picker-dropzone"
        name="benefit_card_img"
        accept="image/jpg,image/jpeg,image/png"
        onDrop={this.handleDrop}
        multiple={false}
        maxSize={MAX_SIZE_BYTES}>
        <CustomTrophyWrapper selected={selected}>
          <Loading load={load} />
          {trophy && !load &&
            <TrophyImg
              isSet
              src={trophy} />
          }
          {!trophy && !load &&
            <Fragment>
              <TrophyImg
                isSet={false}
                src={addTrophy} />
              <CustomTrophyText uppercase>
                <FormattedMessage id="platform.fields.trophy.uploadImage.text" />
              </CustomTrophyText>
            </Fragment>
          }
        </CustomTrophyWrapper>
      </StyledDropzone>
    )
  }
}

export default injectIntl(CustomTrophy)
